/** @jsxImportSource @emotion/react */
import { Text } from "../../../../general/Text";
import { css } from "@emotion/react";
import { modalBodyTextStyle } from "../Approvals.style";
import React from "react";
import { GlobalStore } from "../../../../../store/global/GlobalStore";
import { withIsVisible } from "../../../../../utils/reactUtils";
import { ReactComponent as MetamaskIcon } from "../../../../../img/wallets/Metamask.svg";
import { ReactComponent as GrayCloseButton } from "../../../../../img/butter_svgs/GrayCloseButton.svg";
import { FlexContainer } from "../../../../../containers/FlexContainer";
import styled from "@emotion/styled";
import { NAV_LINKS } from "config/consts";
import { Link } from "react-router-dom";

const MetaMaskTip = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const [isVisible, setIsVisible] = React.useState(true);
  if (!isVisible) {
    return null;
  }
  return (
    <MetaMaskTipContainer>
      <FlexContainer
        justifyContent={"space-between"}
        css={css`
          align-items: center;
          margin-bottom: 4px;
        `}
      >
        <div
          css={css`
            flex-grow: 1;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          `}
        >
          <MetamaskIcon style={{ width: "24", height: "24" }} />
          <Text
            textStyle={"Title"}
            size={"Small"}
            color={"#F5841F"}
            textCss={css`
              display: inline-block;
            `}
          >
            Hey there, MetaMask user!{" "}
          </Text>
        </div>
        <GrayCloseButton
          style={{ cursor: "pointer", border: "none" }}
          onClick={e => {
            setIsVisible(false);
            e.stopPropagation();
            e.preventDefault();
          }}
        />
      </FlexContainer>
      <Text
        shouldScale={false}
        size="Large"
        textStyle="Paragraph"
        textCss={css`
          ${modalBodyTextStyle(theme)};
          max-width: 344px;
        `}
        color={theme.font.secondary.default}
      >
        To save time and money each time you trade, we recommend not changing the default custom
        spending cap in MetaMask.{" "}
        <Link to={NAV_LINKS.FAQ} target="_blank" rel="nofollow noreferrer">
          <Text
            textStyle={"Paragraph"}
            size={"Large"}
            color={theme.font.primary.default}
            textCss={css`
              display: inline-block;
            `}
          >
            Learn why...
          </Text>
        </Link>
      </Text>
    </MetaMaskTipContainer>
  );
};

const MetaMaskTipContainer = styled.div`
  padding: 14px;
  border-radius: 24px;
  background-color: ${props => props.theme.button.tertiary.surface.active};
`;

export default withIsVisible(MetaMaskTip);
